import { Story, AdvancedNewsManager } from '@benzinga/advanced-news-manager';
import { SafePromise } from '@benzinga/safe-await';

import { filterRelatedNodes, getArticleChannelsNames, getArticleTickers } from '../utils';

import { BasicNewsManager, News, NodeQueryParams } from '@benzinga/basic-news-manager';
import { NewsDisplayOutputTypes } from '@benzinga/internal-news-manager';
import { Session } from '@benzinga/session';
import { ArticleData } from '../entities/article';

interface RelatedArticlesOptions {
  length?: number;
  page?: number;
  pageSize?: number;
  displayOutput?: NewsDisplayOutputTypes;
}

export const getRelatedArticles = async (
  session: Session,
  articleData: ArticleData,
  advancedNewsManager: AdvancedNewsManager,
  options?: RelatedArticlesOptions,
): SafePromise<News[]> => {
  const article = new Story(articleData as unknown as any, advancedNewsManager, undefined);

  const params: NodeQueryParams = {
    displayOutput: options?.displayOutput || 'abstract',
    page: options?.page ?? 0,
    pageSize: options?.pageSize || 100,
    sort: undefined,
  };

  const tickers = getArticleTickers(article);
  if (tickers.length) {
    params['symbols'] = [tickers[0]];
  }

  const channels = getArticleChannelsNames(article);
  if (channels.length) {
    params['channels'] = [channels[0]];
  }

  const basicNewsManager = session.getManager(BasicNewsManager);
  const newsResponse = await basicNewsManager.fetchNodes(params);

  if (newsResponse.err) {
    return newsResponse;
  } else {
    const relatedArticles = filterRelatedNodes(article, newsResponse.ok);

    return { ok: relatedArticles.slice(0, options?.length || 4) };
  }
};
